import { createContext } from 'react';
import { AvailableCulture } from '../../../../../../../../../hooks/cultures/useCultures';

export const LanguageContext = createContext<AvailableCulture | undefined>(
  undefined
);
